const themes = {
	light: {
		primaryTextColor: '#FBF0C2',
		secondaryTextColor: '#000',
		additionalTextColor: 'rgba(251, 240, 194, .2)',
    primaryBorderColor: '#FBF0C2',
    buttonDefaultColor: '#FBF0C2',
		buttonDisabledColor: '#A7A7A7',
		buttonDisabledTextColor: '#000',
    inputDefaultColor: '#FFF',
    blankColor: '#000'
	},
	dark: {
		primaryTextColor: '#262626',
		secondaryTextColor: '#363740',
		primaryBorderColor: '#E4E4E4',
    additionalTextColor: '#9D9D9D',
    primaryButtonColor: '#000',
    inputDefaultColor: '#FFF',
    blankColor: '#F1F1F1',
		buttonDisabledColor: '#A7A7A7',
		buttonDisabledTextColor: '#808080',
	}
}

export default themes